import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  resolvedCount: 0,
  // Mapa branch_id -> {code,name,is_personal} de TODAS las sucursales activas
  // (Victor 2026-06-08). Lo manda el index para clasificar chats cross-sucursal.
  branchesMeta: {},
  // Conteo REAL por sucursal { branch_id => total } del scope visible (Victor
  // 2026-06-08). El encabezado de cada sucursal usa esto → número fijo y real.
  branchCounts: {},
};

export const getters = {
  getStats: $state => $state,
  getBranchesMeta: $state => $state.branchesMeta,
  getBranchCounts: $state => $state.branchCounts,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params);
    } else {
      debouncedFetchMetaData(commit, params);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      resolved_count: resolvedCount,
      branches_meta: branchesMeta,
      branch_counts: branchCounts,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    // Conteo real de cerradas (Victor 2026-06-03). Puede no venir en respuestas
    // viejas/cacheadas → conservar el valor previo si llega undefined.
    if (resolvedCount !== undefined) $state.resolvedCount = resolvedCount;
    // Todas las sucursales activas (Victor 2026-06-08): solo se pisa cuando llega
    // (el endpoint /meta no lo trae → conserva el último mapa para clasificar).
    if (branchesMeta && Object.keys(branchesMeta).length) {
      $state.branchesMeta = branchesMeta;
    }
    // Conteo real por sucursal (Victor 2026-06-08): se pisa cuando llega (el index
    // lo trae en cada página con el mismo total → el encabezado queda fijo y real).
    if (branchCounts) {
      $state.branchCounts = branchCounts;
    }
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
